import { AnswerSetResult } from "../../../store/viewmodels/AnswerSetViewModel";
import { AnswerResult } from "../../../store/viewmodels/AnswerViewModel";
import { getClockTime, getDate } from "../../utils/DateServices";

interface StudentBasicResultProps {
    answerSet: AnswerSetResult,
    findErrorAnswers: AnswerResult[],
    combineAnswers: AnswerResult[],
    oneChoiceAnswers: AnswerResult[],
    organizeAnswers: AnswerResult[]
}

function cleanArray(answerArray: string[]): string[] {
    let cleanedArray = answerArray;
    for(let i: number = 0; i < cleanedArray.length; i++) {
        if(cleanedArray[i] === "") {
            cleanedArray.splice(i, 1);
            i--;
        }
    }
    return cleanedArray;
} 

function StudentBasicResult(props: StudentBasicResultProps): JSX.Element {
    let corrects: number = 0;
    let all = 0;

    for (let f: number = 0; f < props.findErrorAnswers.length; f++) {
        let answer = props.findErrorAnswers[f];

        if (answer.value === answer.item?.correct) {
            corrects++;
        }
        all++;
    }

    for (let c: number = 0; c < props.combineAnswers.length; c++) {
        let answer = props.combineAnswers[c]
        let answerArray = answer.value.split(";");
        let cleanedAnswerArray = cleanArray(answerArray);

        let correct = true;
        for (let j: number = 0; j < cleanedAnswerArray.length; j++) {
            let pair = cleanedAnswerArray[j].split("|");
            if (!(pair[0] === pair[1])){
                correct = false;
                break;
            };
        }

        if (correct) {
            corrects++;
        }
        all++;
    }

    for (let m: number = 0; m < props.oneChoiceAnswers.length; m++) {
        let answer = props.oneChoiceAnswers[m];
        if (answer.value === answer.item.correct) {
            corrects++;
        }
        all++;
    }

    for (let o: number = 0; o < props.organizeAnswers.length; o++) {
        let answer = props.organizeAnswers[o];
        if (answer.value === answer.item.correct) {
            corrects++;
        }
        all++;
    }

    const time = new Date(Date.parse(props.answerSet.end_time));
    const date = getDate(time);
    const clockTime = getClockTime(time);

    let correctsColor = "";
    let stars = <></>;
    if (all === corrects) {
        correctsColor = " text-green-600 font-bold "
        stars = (
            <div key={"stars_allOK" + props.answerSet.end_time}>
                <span className="ri-star-fill text-yellow-500"></span>
                <span className="ri-star-fill text-yellow-500"></span>
                <span className="ri-star-fill text-yellow-500"></span>
            </div>
        );
    } else if (corrects >= all / 2) {
        stars = (
            <div key={"stars_halfOK" + props.answerSet.end_time}>
                <span className="ri-star-fill text-yellow-400"></span>
                <span className="ri-star-half-line text-yellow-400"></span>
            </div>
        );
    }

    return (
        <div className={"flex w-full" + correctsColor} key={"answerRow_" + props.answerSet.end_time}>
            <div className="w-1/12 ml-0 mr-1" key={"corrects_" + props.answerSet.end_time}>{corrects}</div>
            <div className="w-1/12 mr-1 ml-1" key={"all_" + props.answerSet.end_time}>{all}</div>
            <div className="w-1/3 mr-1 ml-1" key={"date_" + props.answerSet.end_time}>{date + " " + clockTime}</div>
            <div className="mr-0 ml-1" key={"starcolumn_" + props.answerSet.end_time}>{stars}</div>
        </div>
    );
}

export default StudentBasicResult;